import styled from '@emotion/styled';

import ModalContainer from '../ModalContainer';
import { useNavigate } from 'react-router';
import { ACCOUNT, SIGNIN } from '../../../routes/routeConstants';

const GuestPromptModal = ({ locum }: { locum?: boolean }) => {
  const navigate = useNavigate();

  return (
    <ModalContainer width="50rem">
      <Container>
        <Text>{locum ? 'Continue as a Recruiter' : 'Continue as a User'}</Text>
        <Small>
          The fun does not have to end here, to continue{' '}
          {locum ? 'discovering' : 'explorng'} more{' '}
          {locum ? 'locums ' : 'jobs '}
          please sign in as a {locum ? 'Recruiter' : 'User'}
        </Small>
        <Button
          onClick={() => {
            navigate(`/${ACCOUNT}/${SIGNIN}`);
          }}
          className="fillParent"
        >
          SIGN IN
        </Button>
      </Container>
    </ModalContainer>
  );
};

export default GuestPromptModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  max-width: 600px;
`;

const Text = styled.div`
  color: ${({ theme }) => theme.palette.blackBlackMain};
  font-size: 32px;
  font-weight: 500;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const Small = styled.p`
  font-family: Kanit;
  font-weight: 300;
  font-size: 20px;
  line-height: 29.9px;
  letter-spacing: -2%;
  text-align: center;
  max-width: 450px;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const Button = styled.button`
  background: ${({ theme }) => theme.palette.mainBlue};
  font-weight: 600;
  font-size: 18px;
  color: white;
  border: 1px solid transparent;
  cursor: pointer;
  width: fit-content;
  white-space: nowrap;

  /* for the spinner */
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  padding: 14px;

  /*  */
  &.placeLeft {
    width: fit-content;
    margin-left: auto;
  }

  &.fillParent {
    width: 100%;
  }

  &:disabled {
    cursor: not-allowed;
    background: ${({ theme }) => theme.palette.greyGrey3};
  }

  &.max-width-40rem {
    width: 100%;
    max-width: 40rem;
  }

  &.small {
    padding: 0.5rem 4rem;
    font-weight: 500;
    font-size: 14px;
  }
  &.h-fit-flex-end {
    height: fit-content;
    align-self: flex-end;
  }

  &.right-mt {
    margin-top: 32px;
    margin-left: auto;
  }

  &.notification {
    padding: 10px 16px;
    font-weight: 400;
  }

  @media (max-width: 768px) {
    &.max-width-40rem {
      width: 180px;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
    }
  }

  @media (max-width: 480px) {
    &.notification {
      font-size: 14px;
      padding: 0.3rem 10px;
      font-weight: 400;
    }

    &.fillParent {
      padding: 10px;
    }
  }
`;
